import {
  HomeRecognition,
  MySettings,
  PoolPositions,
  RecognizeOptions,
  Waiting,
  type UpdateMySettings,
} from '@myrewards/contracts';
import { queryOptions } from '@tanstack/react-query';
import { request } from './client';

/** Waiting on you: every role's waiting work, oldest first (`GET /api/v1/home/waiting`). */
export const waitingQuery = queryOptions({
  queryKey: ['home', 'waiting'] as const,
  queryFn: ({ signal }) => request('/api/v1/home/waiting', { schema: Waiting, signal }),
  staleTime: 60_000,
});

/** Home's recognition cards and the person's own awards (`GET /api/v1/home/recognition`). */
export const recognitionQuery = queryOptions({
  queryKey: ['home', 'recognition'] as const,
  queryFn: ({ signal }) => request('/api/v1/home/recognition', { schema: HomeRecognition, signal }),
  staleTime: 60_000,
});

/** Each visible pool's position for the year (`GET /api/v1/budgets`). */
export const budgetsQuery = queryOptions({
  queryKey: ['budgets', 'current'] as const,
  queryFn: ({ signal }) => request('/api/v1/budgets', { schema: PoolPositions, signal }),
  staleTime: 60_000,
});

/** What this person can start on Recognize (`GET /api/v1/recognize/options`). */
export const recognizeOptionsQuery = queryOptions({
  queryKey: ['recognize', 'options'] as const,
  queryFn: ({ signal }) =>
    request('/api/v1/recognize/options', { schema: RecognizeOptions, signal }),
  staleTime: 5 * 60_000,
});

/** My settings (`GET /api/v1/me/settings`). */
export const mySettingsQuery = queryOptions({
  queryKey: ['me', 'settings'] as const,
  queryFn: ({ signal }) => request('/api/v1/me/settings', { schema: MySettings, signal }),
});

/**
 * Saves part of My settings (`PATCH /api/v1/me/settings`) and returns all of them. Kept alive,
 * so a choice made just before a reload (Rows per page, say) still lands.
 */
export function updateMySettings(patch: UpdateMySettings): Promise<MySettings> {
  return request('/api/v1/me/settings', {
    method: 'PATCH',
    body: patch,
    schema: MySettings,
    keepalive: true,
  });
}
